import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//

export default {
  name: 'BubbleCorner',
  props: {
    messages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxWidth: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentText: '',
      isBadgeAnimating: false,
      isLabelOut: false,
      currentIdx: 0,
      outerTimer: null,
      // 外层轮播定时器：控制每条消息的展示间隔（perItem ms）
      innerTimer: null,
      // 内层动画定时器：控制退出动画结束后（outMs ms）执行文字切换
      outMs: 300,
      perItem: 3000
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.clearAllTimers();
  },
  watch: {
    messages: {
      immediate: true,
      handler: function handler(newVal) {
        this.clearAllTimers();
        this.currentIdx = 0;
        this.currentText = newVal && newVal.length > 0 ? newVal[0] : '';
        this.isBadgeAnimating = false;
        this.isLabelOut = false;
        if (newVal && newVal.length > 1) {
          this.startLoop();
        }
      }
    }
  },
  methods: {
    clearAllTimers: function clearAllTimers() {
      if (this.outerTimer) {
        clearTimeout(this.outerTimer);
        this.outerTimer = null;
      }
      if (this.innerTimer) {
        clearTimeout(this.innerTimer);
        this.innerTimer = null;
      }
    },
    startLoop: function startLoop() {
      this.scheduleNext(this.perItem);
    },
    scheduleNext: function scheduleNext(delay) {
      var _this = this;
      if (this.outerTimer) {
        clearTimeout(this.outerTimer);
      }
      this.outerTimer = setTimeout(function () {
        _this.performSwitch();
      }, delay);
    },
    performSwitch: function performSwitch() {
      var _this2 = this;
      this.isBadgeAnimating = true;
      this.isLabelOut = true;
      this.innerTimer = setTimeout(function () {
        _this2.innerTimer = null;
        _this2.currentIdx = (_this2.currentIdx + 1) % _this2.messages.length;
        _this2.currentText = _this2.messages[_this2.currentIdx];
        _this2.isLabelOut = false;
        _this2.isBadgeAnimating = false;
        // 减去动画耗时，保持每条展示时长精确为 perItem
        _this2.scheduleNext(_this2.perItem - _this2.outMs);
      }, this.outMs);
    }
  }
};